import { UniversalSearchCategory, UniversalSearchCategoryQueryValue } from '@/app/(pages)/results/constants';

export const getCategoryQueryValueFromKey = (key?: string) => {
  if (!key) return UniversalSearchCategoryQueryValue.LOCAL_ACCOMMODATION;

  return (
    {
      [UniversalSearchCategory.LOCAL_ACCOMMODATION]: UniversalSearchCategoryQueryValue.LOCAL_ACCOMMODATION,
      [UniversalSearchCategory.GLOBAL_ACCOMMODATION]: UniversalSearchCategoryQueryValue.GLOBAL_ACCOMMODATION,
      [UniversalSearchCategory.LOCAL_LEISURE]: UniversalSearchCategoryQueryValue.LOCAL_LEISURE,
      [UniversalSearchCategory.ENTERTAINMENT]: UniversalSearchCategoryQueryValue.ENTERTAINMENT,
    }[key] || UniversalSearchCategoryQueryValue.LOCAL_ACCOMMODATION
  );
};
